import React, { FC } from 'react';
import { IconType } from '../../../models/Icon';

interface Props {
  type: IconType;
  className: string; // Set colors and sizes
}

const Icon: FC<Props> = ({ type, className }) => {
  switch (type) {
    case 'chevronRightFilled':
      return (
        <svg
          className={`aea-form-icon ${className}`}
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="40" height="40" rx="20" fill="currentColor" />
          <path
            d="M17 28L25 20L17 12"
            fill="currentColor"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'chevronLeftFilled':
      return (
        <svg
          className={`aea-form-icon ${className}`}
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            width="40"
            height="40"
            rx="20"
            transform="matrix(-1 0 0 1 40 0)"
            fill="currentColor"
          />
          <path
            d="M23 28L15 20L23 12"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'party':
      return (
        <svg
          className={`aea-form-icon ${className}`}
          viewBox="0 0 53 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.3951 16.0208C14.9242 16.1034 14.5279 16.4203 14.3438 16.8612L0.117103 51.039C-0.0704599 51.4683 -0.0308638 51.9629 0.222616 52.3569C0.476095 52.751 0.909901 52.9923 1.37859 53L1.93925 52.8599L36.1395 38.6425C36.5772 38.4595 36.8925 38.0675 36.9774 37.601C37.0622 37.1345 36.9052 36.6567 36.56 36.3313L16.6566 16.441C16.3335 16.0979 15.8595 15.9399 15.3951 16.0208ZM10.6295 33.1097L12.9422 27.5768L25.4169 40.0433L19.8803 42.3545L10.6295 33.1097ZM11.5405 45.8563L17.077 43.5451L9.43806 35.9111L7.12535 41.444L11.5405 45.8563ZM6.00403 44.2455L8.80732 47.0469L4.04172 49.0079L6.00403 44.2455ZM28.2202 38.8527L33.1259 36.8216L16.166 19.8728L14.1336 24.7753L28.2202 38.8527Z"
            fill="currentColor"
          />
          <path
            d="M21 19.4205L22.6462 21C24.1723 19.5265 25.2323 17.6685 25.7035 15.641C26.1516 13.7774 26.0909 11.8345 25.5272 10L23.293 10.6769C23.7276 12.1285 23.768 13.6625 23.4106 15.1333C23.0465 16.7526 22.2106 18.2394 21 19.4205Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.6889 10L20.8444 7.16814L18 6.37168L20.0444 4.24779L19.3333 1.37168L22.2222 2.0354L24.3556 0L25.1556 2.83186L28 3.67257L25.9556 5.79646L26.6667 8.67257L23.8222 7.9646L21.6889 10ZM22.7436 4.01709L21.8034 3.80342L22.0171 4.74359L21.3333 5.47009L22.2735 5.7265L22.5299 6.66667L23.2564 5.98291L24.1966 6.19658L23.9829 5.25641L24.6667 4.52991L23.7265 4.2735L23.4701 3.33333L22.7436 4.01709Z"
            fill="currentColor"
          />
          <path
            d="M37.359 27.2965C35.3315 27.7677 33.4735 28.8277 32 30.3538L33.5795 32C34.7606 30.7894 36.2474 29.9535 37.8667 29.5894C39.3375 29.232 40.8715 29.2724 42.3231 29.707L43 27.4728C41.1655 26.9091 39.2226 26.8484 37.359 27.2965Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M48.9602 24L49.885 27.08L53 28.0089L50.7611 30.3556L51.5398 33.5333L48.3761 32.7511L46.0398 35L45.115 31.8711L42 30.9911L44.2389 28.6444L43.4602 25.4667L46.6239 26.2489L48.9602 24ZM46.9183 31.5625L47.8173 30.7163L48.9808 30.9808L48.7163 29.8173L49.5625 28.9183L48.399 28.601L48.0817 27.4375L47.1827 28.2837L46.0192 28.0192L46.2837 29.1827L45.4375 30.0817L46.601 30.399L46.9183 31.5625Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M37.6239 11.2389L39.9602 9L40.885 12.115L44 13.0398L41.7611 15.3274L42.5398 18.4912L39.3761 17.7611L37.0398 20L36.115 16.885L33 15.9602L35.2389 13.6239L34.5088 10.4602L37.6239 11.2389ZM37.9183 16.5625L38.8173 15.7163L39.9808 15.9808L39.7163 14.8173L40.5625 13.9183L39.399 13.601L39.0817 12.4375L38.1827 13.2837L37.0192 13.0192L37.2837 14.1827L36.4375 15.0817L37.601 15.399L37.9183 16.5625Z"
            fill="currentColor"
          />
          <path
            d="M27 24.3838L33.3838 18L35 19.6162L28.6162 26L27 24.3838Z"
            fill="currentColor"
          />
          <circle cx="13.5" cy="10.5" r="1.5" fill="currentColor" />
          <circle cx="32.5" cy="2.5" r="1.5" fill="currentColor" />
          <circle cx="37.5" cy="24.5" r="1.5" fill="currentColor" />
          <circle cx="51.5" cy="19.5" r="1.5" fill="currentColor" />
          <circle cx="44.5" cy="39.5" r="1.5" fill="currentColor" />
        </svg>
      );
    case 'info':
      return (
        <svg
          className={`aea-form-icon ${className}`}
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11 22C4.934 22 0 17.065 0 11S4.934 0 11 0s11 4.934 11 11c0 6.065-4.934 11-11 11Zm1.058-16.32c0-.564-.456-1.02-1.019-1.02h-.079a1.019 1.019 0 0 0 0 2.038h.08c.562 0 1.018-.456 1.018-1.019ZM11 8.935c.584 0 1.058.474 1.058 1.058v6.288a1.058 1.058 0 1 1-2.116 0V9.994c0-.584.473-1.058 1.058-1.058Z"
            fill="currentColor"
          />
        </svg>
      );
    case 'close':
      return (
        <svg
          className={`aea-form-icon ${className}`}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
        >
          <path fill="none" d="M0 0h24v24H0z" />
          <path
            fill="currentColor"
            d="m12 10.586 4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z"
          />
        </svg>
      );
    case 'attachment':
      return (
        <svg
          className={`aea-form-icon ${className}`}
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="m15.5 6.6-7.318 7.319a4.5 4.5 0 1 1-6.364-6.364l6.01-6.01a3 3 0 1 1 4.243 4.242L6.06 11.8a1.5 1.5 0 0 1-2.122-2.12L9.95 3.666"
            stroke="currentColor"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'trash':
      return (
        <svg
          className={`aea-form-icon ${className}`}
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.63135 4.28497H14.3685"
            stroke="currentColor"
            fill='none'
            strokeWidth="1.14"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3.22363 4.28497H12.7765V13.8378C12.7765 14.1193 12.6646 14.3893 12.4656 14.5884C12.2666 14.7874 11.9966 14.8993 11.7151 14.8993H4.28506C4.00355 14.8993 3.73357 14.7874 3.53451 14.5884C3.33546 14.3893 3.22363 14.1193 3.22363 13.8378V4.28497Z"
            stroke="currentColor"
            fill='none'
            strokeWidth="1.14"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5.34619 4.28499V3.75428C5.34619 3.05051 5.62576 2.37556 6.1234 1.87792C6.62104 1.38028 7.29599 1.10071 7.99976 1.10071C8.70353 1.10071 9.37848 1.38028 9.87612 1.87792C10.3738 2.37556 10.6533 3.05051 10.6533 3.75428V4.28499"
            stroke="currentColor"
            fill='none'
            strokeWidth="1.14"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.40771 7.47083V11.7182"
            stroke="currentColor"
            fill='none'
            strokeWidth="1.14"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9.59229 7.47083V11.7182"
            stroke="currentColor"
            fill='none'
            strokeWidth="1.14"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    default:
      return null;
  }
};

export default Icon;
